﻿import api from '../api';

export interface TipoClausula {
    id: string;
    nome: string;
}

export const getAllTipoClausula = () => api.get<TipoClausula[]>('TipoClausula');

export const Get = (id: string) => api.get('TipoClausula/${id}');

export const getTipoClausulaByClausulaId = (clausulaId: string) => api.get(`TipoClausula/clausula/${clausulaId}`);

export const getAllTipoClausulaOptions = () => getAllTipoClausula().then(tipoClausulas => (tipoClausulas || [])
    .sort((a, b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0))
    .map(t => ({ text: t.nome, value: t.id.toString() })))